// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_h1-0";
export var buttonContainer = "_h1-3";
export var cancelButton = "_h1-4";
export var headerSection = "_h1-6";
export var headerTitle = "_h1-9";
export var messageSideLeft = "_h1-1";
export var messageSideRight = "_h1-2";
export var orderNumberContainer = "_h1-7";
export var orderNumberLabel = "_h1-8";
export var submitButton = "_h1-5";